import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useAuth } from "./context/AuthContext";
import Layout from "./containers/layout";
import AuthRoutes from "./components/AuthRoutes";
import UnauthRoutes from "./components/UnauthRoutes";
import LoginPage from "./modules/auth/views/LoginPage";
import LogoutPage from "./modules/auth/views/LogoutPage";
import PostManagement from "./modules/posts/views/PostManagement";
import SettingContainer from "./modules/setting/views/SettingContainer";
import { Result } from "antd";
import PageManagement from "./modules/pages/views/PageManagement";

const App = () => {
  const { loadUserSuccess, loadUserFaiture } = useAuth();

  useEffect(() => {
    onLoadAuth();
  }, []);

  const onLoadAuth = () => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        loadUserSuccess(user);
      } else {
        loadUserFaiture();
      }
    });
  };

  return (
    <Routes>
      <Route element={<UnauthRoutes />}>
        <Route path="/login" element={<LoginPage />}></Route>
      </Route>
      <Route element={<AuthRoutes />}>
        <Route path="/*" element={<Layout />}>
          <Route path="logout" element={<LogoutPage />}></Route>
          <Route path="pages" element={<PageManagement />}></Route>
          <Route path="posts" element={<PostManagement />}></Route>
          <Route path="setting" element={<SettingContainer />}></Route>
          <Route
            path="*"
            element={<Navigate to="/pages" replace={true} />}
          ></Route>
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
